var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.971,
    viewBox: "0 0 30 29.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.671-85,29.462-96.789a1.885,1.885,0,0,0,0-2.64,1.885,1.885,0,0,0-2.64,0L15-87.668,3.211-99.459a1.885,1.885,0,0,0-2.64,0,1.885,1.885,0,0,0,0,2.64L12.332-85,.541-73.208a1.885,1.885,0,0,0,0,2.64,1.862,1.862,0,0,0,1.32.54,1.86,1.86,0,0,0,1.32-.54L15-82.358,26.792-70.568a1.862,1.862,0,0,0,1.32.54,1.86,1.86,0,0,0,1.32-.54,1.885,1.885,0,0,0,0-2.64Z",
    transform: "translate(-0.002 99.999)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.b6e728d3.svg";
export { ForwardRef as ReactComponent };